import { Button, Typography } from '@mui/material';
import { Home } from '@mui/icons-material';
import localize from '../common/localize';
import ApplicationLogoVertical from './common/ApplicationLogoVertical';

const NoMatch = () => (
  <div className="flex flex-col h-screen w-full justify-center content-center items-center">
    <ApplicationLogoVertical height={150} width={150} />
    <div className="my-5" />
    <Typography fontSize={20} align="center">
      {localize.route_not_found}
    </Typography>
    <div className="my-5" />
    <Button
      size="large"
      variant="contained"
      className="app_general_button_data app_button btn-sm "
      href="/"
    >
      <Home />
      <div className="mx-1" />
      {localize.back_to_home}
    </Button>
  </div>
);

export default NoMatch;
